<template>
  <b-container fluid>
    <b-row>
      <b-col>
        Logout
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
/* eslint-disable */

// URL paramas
// https://www.thepolyglotdeveloper.com/2017/11/pass-data-between-routes-vuejs-web-application/
// import router from "../router";

import service from "@/service/service";

var data = {
  msg: "Viva Account Logout",
  debug: false,
  loading: true,
  error: false,
  studentHash: "",
  classHash: "",
};

// using props for url parameters
// https://www.youtube.com/watch?v=ESg0k2zdME4

export default {
  name: "Logout",
  data() {
    return data;
  },
  methods: {
    logout() {
      // the final use of location.reload() will kill all data except localstorage.
      this.$root.setToken('')
      this.$root.setStudentHash('')
      this.$root.setStudentName('')
      this.$root.setStudentEmail('')
      this.$root.setClassHash('')
      this.$root.setStudentId(0)
      localStorage.setItem('id_token',null)
      localStorage.clear()
      this.$router.push("/login").then( () => { location.reload() })
    }
  },
  created() { this.logout() },
  mounted() { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-header h2 {
  color: white;
  background-color: black;
  padding: 10px 0px;
}
.col {
  border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue